import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import THEME from 'theme';
import { Heading } from 'components/chroma';
import { TextSmall } from 'components/chroma/extended';

const VALID_FOR_60_DAYS = 'Valid for 60 days';
const VALID_DATE = 'Valid until 31st August 2024.';
const VALID_DATE_NOTE =
  'This quote is an indication only and not guaranteed. Any changes, including the policy start date, may alter the quoted premium.';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  border-top: 1px solid ${THEME.FIELD.BORDER.LIGHT};
  padding-top: 0.5em;
`;

const DesktopWrapper = styled.div`
  background-color: ${THEME.BACKGROUND.CARD};
  min-height: 120px;
  padding: 1.5em 2em 1em 2em;
  margin-top: 1em;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const QuoteInformationContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const toHeader = (quoteNumber: string): string => `QUOTE No.: ${quoteNumber}`;

type QuoteNumberCardProps = {
  sidebarDisplay?: Boolean;
  quoteNumber: string;
  isBeforeEffectiveEndDate?: Boolean;
};

const QuoteNumberCard: FunctionComponent<QuoteNumberCardProps> = ({
  sidebarDisplay,
  quoteNumber,
  isBeforeEffectiveEndDate,
}) => (
  <>
    {sidebarDisplay ? (
      <DesktopWrapper>
        <div>
          <Heading size={4} margin={{ top: 4, bottom: 1 }} fontSize={16}>
            {toHeader(quoteNumber)}
          </Heading>
          {isBeforeEffectiveEndDate ? (
            <TextSmall margin={{ bottom: 4 }}>{VALID_FOR_60_DAYS}</TextSmall>
          ) : (
            <>
              <TextSmall margin={{ bottom: 1 }}>{VALID_DATE}</TextSmall>
              <TextSmall margin={{ bottom: 1 }} style={{ fontStyle: 'italic' }}>
                {VALID_DATE_NOTE}
              </TextSmall>
            </>
          )}
        </div>
      </DesktopWrapper>
    ) : (
      <Wrapper>
        <QuoteInformationContainer>
          <div>
            <Heading
              size={4}
              margin={{ top: 4, bottom: 1, left: 3 }}
              fontSize={14}
            >
              {toHeader(quoteNumber)}
            </Heading>
            {isBeforeEffectiveEndDate ? (
              <TextSmall margin={{ left: 3, bottom: 1 }}>
                {VALID_FOR_60_DAYS}
              </TextSmall>
            ) : (
              <>
                <TextSmall margin={{ left: 3, bottom: 1 }}>
                  {VALID_DATE}
                </TextSmall>
                <TextSmall
                  margin={{ left: 3, bottom: 4 }}
                  style={{ fontStyle: 'italic' }}
                >
                  {VALID_DATE_NOTE}
                </TextSmall>
              </>
            )}
          </div>
        </QuoteInformationContainer>
      </Wrapper>
    )}
  </>
);

export default QuoteNumberCard;
